import axiosInstance from '../../utility/axios';
import { POST_TYPE_NAME } from '../../utility/constants';

export const showError = (errorMessage) => ({
    type: 'SHOW_ERROR',
    errorMessage
});

export const startEMCStat = () => ({
    type: 'START_GET_EMC_STAT',
});

export const getEMCStatSuccess = (emcStat) => ({
    type: 'GET_EMC_STAT_SUCCESS',
    emcStat
});

export const getEMCStat = (id) => {
    return (dispatch) => {
        dispatch(startEMCStat());
        axiosInstance.get(`emc-stat/${id}`)
            .then((response) => {
                if (response.data.job === false) { // no post yet
                } else { // has post
                    console.log('response.data in email stat: ', response.data);
                    dispatch(getEMCStatSuccess(response.data));
                }
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startGetEMCStats = () => ({
    type: 'START_GET_EMC_STATS',
});

export const getEMCStatsSuccess = (emcStats) => ({
    type: 'GET_EMC_STATS_SUCCESS',
    emcStats
});

export const getEMCStats = (queryParams) => {
    return (dispatch) => {
        let url = 'emc-stats';
        if (queryParams) {
            url = `emc-stats/${queryParams}`;
        }
        console.log('get emc-stats url: ', url);
        dispatch(startGetEMCStats());
        axiosInstance.get(url)
            .then((response) => {
                dispatch(getEMCStatsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startCreateEMCStat = () => ({
    type: 'START_CREATE_EMC_STAT'
});

export const createEMCStatSuccess = (emcStat) => ({
    type: 'CREATE_EMC_STAT_SUCCESS',
    emcStat
});

export const createEMCStat = (emcStat) => {
    console.log('creating emc-stats', emcStat);
    return (dispatch) => {
        dispatch(startCreateEMCStat());
        axiosInstance.post('emc-stat', emcStat)
            .then((response) => {
                dispatch(createEMCStatSuccess(response.data));
            })
            .catch((error) => {
                dispatch(showError());
                console.log(error);
            });
    }
};

export const startEMCStatUpdate = () => ({
    type: 'START_EMC_STAT_UPDATE',
});

export const updateEMCStatSuccess = (emcStatDetails) => ({
    type: 'UPDATE_EMC_STAT_SUCCESS',
    emcStatDetails
});

export const updateEMCStat = (emcStatDetails, emcStatId) => {
    return (dispatch) => {
        dispatch(startEMCStatUpdate());
        axiosInstance.put(`emc-stat/${emcStatId}`, emcStatDetails)
            .then((response) => {
                dispatch(updateEMCStatSuccess(emcStatDetails));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startRemoveEMCStat = () => ({
    type: 'START_REMOVE_EMC_STAT'
});

export const removeEMCStatSuccess = (emcStatId) => ({
    type: 'REMOVE_EMC_STAT_SUCCESS',
    emcStatId
});

export const removeEMCStat = (id) => {
    return (dispatch) => {
        dispatch(startRemoveEMCStat());
        axiosInstance.delete(`emc-stat/${id}`)
            .then((response) => {
                dispatch(removeEMCStatSuccess(id));
                console.log('emc-stat removed!: ', id);
            })
            .catch((error) => {
                dispatch(showError());
                console.log(error);
            });
    }
};

